module.exports = __webpack_public_path__ + "img/1LNG_Cover.9d2bf815.jpg";